module.exports = __webpack_public_path__ + "img/54.114a6bb5.jpg";